import React, { ReactElement } from 'react'

import { Container } from '@/styles/pages/DevToDev'
import SEO from '@/components/SEO'

export default function DevToDev(): ReactElement {
  return (
    <Container>
      <SEO
        title="Dev to Dev"
        description="Conteúdos, experiências e projetos de Carlos Miguel como desenvolvedor."
      />
      <h1>Dev to Dev</h1>
    </Container>
  )
}
